module.exports = __webpack_public_path__ + "img/icon-cashback-statistic-usa.8d45b7ac.svg";